/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Actual_BagsInputs */

const en_audit_actual_bags = /** @type {(inputs: Audit_Actual_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actual Bags`)
};

const es_audit_actual_bags = /** @type {(inputs: Audit_Actual_BagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sacos Reales`)
};

/**
* | output |
* | --- |
* | "Actual Bags" |
*
* @param {Audit_Actual_BagsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_actual_bags = /** @type {((inputs?: Audit_Actual_BagsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Actual_BagsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_actual_bags(inputs)
	return es_audit_actual_bags(inputs)
});